import React, { Component } from 'react';

import { Modal } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';

class ScheduleChange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleLocalChange = this.handleLocalChange.bind(this);
  }

  handleLocalChange(date) {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    return {
      target: {
        value: date,
      },
    };
  }

  render() {
    return (
      <div>
        {this.props.edit && (
          <Modal show={this.props.edit}>
            <Modal.Header>
              <Modal.Title>{this.props.prettyName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <DateTimePicker
                onChange={(value) => {
                  this.props.handleChange(this.handleLocalChange(value));
                }}
                value={new Date(this.props.date)}
              />
              <font className="mandatory">{this.props.errorString}</font>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                onClick={this.props.handleClose}
                type="button"
                className="btn modalButtons btn-warning"
              >
                Close
              </button>
              <button
                onClick={this.props.handleSave}
                type="button"
                className="btn modalButtons btn-success"
              >
                Save
              </button>
            </Modal.Footer>
          </Modal>
        )}
      </div>
    );
  }
}

export default ScheduleChange;
